function initProfile() {
    if (document.querySelector(".profile-section__btn-edit-js") != null) {
        try {
            const btnEdit = document.querySelector(".profile-section__btn-edit-js");
            const form = document.querySelector(".profile-section__form--js");
            const nameElemValue = document.querySelectorAll(
                ".profile-section__name-element-value--js"
            );
            const inputs = document.querySelectorAll(".profile-section__input--js");

            const originalValues = [];
            nameElemValue.forEach(elem => {
                originalValues.push(elem.textContent.trim());
            });

            btnEdit.addEventListener("click", (e) => {
                e.preventDefault();
                form.classList.add("profile-section__form--active");

                inputs.forEach((itemInput, indexInput) => {
                    itemInput.value = originalValues[indexInput];
                });
            });

            form.addEventListener("submit", (e) => {
                e.preventDefault();

                inputs.forEach((itemInput, indexInput) => {
                    const newValue = itemInput.value.trim();
                    if (newValue) {
                        nameElemValue[indexInput].textContent = newValue;
                        originalValues[indexInput] = newValue;
                    }
                });

                form.classList.remove("profile-section__form--active");

                console.log("Новые значения сохранены:", originalValues);
            });
        } catch (e) {
            console.error("Ошибка в инициализации профиля:", e);
        }
    }
}